export function campaignsDtoToJ(campaignsDto) {
    const campaigns = [];
    campaignsDto.map((campaignDto) => {
        campaigns.push(campaignDtoToJ(campaignDto));
    });
    return campaigns;
}

export function campaignDtoToJ(campaignDto) {
   return { 
        id: campaignDto.id, 
        company: campaignDto.companyName,
        campaign: campaignDto.occupation,
        country: campaignDto.country,
        ended: !campaignDto.isOpen,
        managerCount: campaignDto.managerCount,
        candidateCount: campaignDto.candidateCount,
        managers: usersDtoToJ(campaignDto.managers),
        recruiters: usersDtoToJ(campaignDto.recruiters),
        createdAt: campaignDto.createdAt,
        createdBy: campaignDto.createdBy,
        closedAt: campaignDto.closedAt,
        createdAtTimestamp: (Date.parse(campaignDto.createdAt)/1000)
    }
}

export function usersDtoToJ(usersDto) {

    const managers = [];
    if (usersDto != null && usersDto.length > 0) {
        usersDto.map((userDto) => {
            managers.push(userDtoToJ(userDto));
        });
    }
    return managers;
}

export function userDtoToJ(userDto) {
    return {
        id: userDto.id,
        label: userDto.email,
        name: userDto.firstName,
        surname: userDto.lastName,
        group: userDto.group,
        role: userDto.role
    };
}

export function campaignJToDto(campaign) {
    return {
        id: campaign.id,
        companyName: campaign.company, 
        occupation: campaign.campaign,
        country: countryJToDto(campaign.country),
        isOpen: !campaign.ended,
        managers: usersJToDto(campaign.managers),
        recruiters: usersJToDto(campaign.recruiters),
        createdAt: campaign.createdAt,
        createdBy: campaign.createdBy,
        closedAt: campaign.closedAt
    }
}

export function usersJToDto(users) {
    const usersDto = [];
    if (users.length > 0) {
        users.map((user) => {
            usersDto.push(userJToDto(user));
        });
    }
    return usersDto;
}

export function userJToDto(user) {
    return {
        id: user.id,
        email: user.label,
        firstName: user.name,
        lastName: user.surname,
        group: user.group,
        role: user.role
    }
}

export function countryJToDto(country) {
    return {
        englishName: country.englishName,
        ietfLanguageTag: country.ietfLanguageTag,
        languageNativeName: country.languageNativeName,
        languageEnglishName: country.languageEnglishName,
        code: country.code,
        value: country.value
    }
}